import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import cn from 'classnames'
import Product from './Product'
import Loader from '../../common/Loader'
import Error from '../../common/Error'
import BuyInOneClick from '../../common/BuyInOneClick'
import trackEvent from '../../../utils/track-event'

export const LAZY_LOAD_IMG_THRESHOLD = 6

export default function Products() {
    const onPlatform = useSelector((state) => state.onPlatform)
    const products = useSelector((state) => state.products)
    const authenticityToken = useSelector((state) => state.authenticityToken)
    const tags = useSelector((state) => state.tags)
    const buyInOneClick = useSelector((state) => state.buyInOneClick)

    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [productId, setProductId] = useState('')

    const openModal = (e) => {
        const productId = e.target.dataset.id

        setModalIsOpen(true)
        setProductId(productId)
        trackEvent({
            category: 'store button',
            action: 'buy_in_one_click_product',
        })
    }

    const closeModal = () => {
        setModalIsOpen(false)
    }

    const isLazyLoadImg = (idx) => {
        if (!products.items) return false

        return idx > products.items.length - LAZY_LOAD_IMG_THRESHOLD
    }

    const loading = products.loading && !products.loadded
    const {error} = products

    return (
        <>
            <If condition={error}>
                <div className="col-xs-12">
                    <Error />
                </div>
            </If>
            <div className={cn('products', 'col-xs-12', {loading})}>
                <If condition={loading}>
                    <Loader />
                </If>
                <For each="product" index="idx" of={products.items}>
                    <div
                        key={product.id}
                        className="products__item col-md-3 col-sm-4 col-xs-6"
                    >
                        <Product
                            product={product}
                            openModal={openModal}
                            authenticityToken={authenticityToken}
                            tags={tags}
                            onPlatform={onPlatform}
                            lazyImg={isLazyLoadImg(idx)}
                        />
                    </div>
                </For>
                <BuyInOneClick
                    buyInOneClick={buyInOneClick}
                    productId={productId}
                    modalIsOpen={modalIsOpen}
                    closeModal={closeModal}
                    authenticityToken={authenticityToken}
                />
            </div>
        </>
    )
}
